import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { BehaviorSubject, Subscription } from "rxjs";

@Component({
  selector: "app-sport-filter",
  imports: [MatCheckboxModule, MatIconModule],
  templateUrl: "./sport-filter.component.html",
  styleUrl: "./sport-filter.component.scss",
})
export class SportFilterComponent {
  @Input() filterItems: any[] = [];
  @Output() handleFilter: EventEmitter<any> = new EventEmitter<any>();
  viewFilter: boolean = true;
}
